<template>
  <div class="toasts-wrapper" v-if="getToasts.length">
    <Toast v-for="toast of getToasts" :toast=toast :key=toast.id />
  </div>
</template>
<script>
import Toast from "@/components/__new_ui_kit/Toast/Toast";
import {mapGetters} from "vuex";
export default {
  name: 'Toasts',
  components: { Toast },
  computed: {
    ...mapGetters(['getToasts']),
  }
}
</script>
<style scoped>
  .toasts-wrapper {
    position: fixed;
    bottom: 16px;
    left: 16px;
    z-index: 100000;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
</style>